import React from "react";
import { useUser } from "../../../../context/AuthContext";
import Scope3ApprovalListCore from "../Scope3ApprovalListCore";
import SimpleScope3ApprovalDrawer from "../SimpleScope3ApprovalDrawer";

const mapLeasedRow = (item) => ({
  ...item,
  assetID:
    item?.asset?.assetId ??
    "",
  typeofAsset:
    item?.asset?.typeOfAsset ??
    "",
  locationCountry:
    item?.asset?.locationCountry ??
    "",
});

const UpstreamView = (props) => (
  <SimpleScope3ApprovalDrawer
    {...props}
    title="Upstream leased assets — change request"
  />
);

const UpstreamLeasedAssetsApproval = () => {
  const { user } = useUser();

  const headings = [
    { title: "Date", key: "createdAt" },
    user?.companyAdmin ? { title: "Facility", key: "facilityName" } : null,
    {
      title: "Consumption Month",
      key: "consumptionPeriod",
    },
    { title: "Asset ID", key: "assetID" },
    // { title: "Type of Asset", key: "typeofAsset" },
    { title: "Status", key: "requestStatus" },
    { title: "Created By", key: "createdBy" },
  ].filter(Boolean);

  return (
    <Scope3ApprovalListCore
      pageTitle="Upstream Leased Assets"
      apiSegment="upstreamLeasedAssets"
      ViewPage={UpstreamView}
      headings={headings}
      columnWidth={
        user?.companyAdmin
          ? "11% 12% 14% 14% 14% 14% 11%"
          : "12% 20% 20% 18% 18% 8%"
      }
      mapRow={mapLeasedRow}
    />
  );
};

export default UpstreamLeasedAssetsApproval;
